/*eslint-disable*/ export const messages = {
    Apply: "適用",
    "Changed the date": "日付が変更されました",
    Clear: "クリア",
    "Date picker open, choose a date": "日付選択カレンダーが開いています。日付を選択してください",
    "Date range picker open, select a date range": "日付範囲選択カレンダーが開いています。日付範囲を選択してください",
    "End Date": "終了日",
    "Please enter a valid date ({format})": ["有効な日付を入力してください (", ["format"], ")"],
    "Please select a date after {minDate}": [["minDate"], " より後の日付を選択してください"],
    "Please select a date before {maxDate}": [["maxDate"], " より前の日付を選択してください"],
    "Show next month": "次の月を表示",
    "Show previous month": "前の月を表示",
    "Start Date": "開始日",
    "The selected date is disabled": "選択した日付は無効です",
    "The selected date is unavailable. Please select another.":
        "選択した日付は使用できません。 別の日付を選択してください。",
    Today: "今日",
    "Today, {dateStr}": ["今日、", ["dateStr"]],
    "date picker": "日付選択カレンダー",
    "start date selected": "開始日が選択されました",
    to: "宛先",
    "{dateStr}, select end date": [["dateStr"], "、終了日を選択"],
    "{dateStr}, select start date": [["dateStr"], "、開始日を選択"],
    "{startDate} to {endDate}, choose apply to confirm, or cancel": [
        ["startDate"],
        " ～ ",
        ["endDate"],
        "、[適用] をクリックして確定、またはキャンセルしてください",
    ],
};
